import { useLocalStorage } from '@fortress-technology-solutions/fortress-component-library/hooks';

/**
 * Hook to enable/disable route manager logging for uninvited secondary users for debugging purposes
 *
 * @returns {Object} Object containing the current state of route manager logging and a function to toggle it
 */
const useEnableUnInvitedSecondaryUserRouteLogging = () => {
  const {
    localStorageState: isUnInvitedSecondaryUserRouteManagerLoggingEnabled,
    setLocalStorage: setUnInvitedSecondaryUserRouteManagerLogging,
  } = useLocalStorage(
    'uninvitedSecondaryUserRouteManagerLogging',
    'boolean',
    false,
  );

  return {
    isUnInvitedSecondaryUserRouteManagerLoggingEnabled,
    toggleIsUnInvitedSecondaryUserRouteManagerLoggingEnabled: () =>
      setUnInvitedSecondaryUserRouteManagerLogging(
        !isUnInvitedSecondaryUserRouteManagerLoggingEnabled,
      ),
  };
};

export default useEnableUnInvitedSecondaryUserRouteLogging;
